import Icon from 'assets/images/logo_ume_header.png';
import './styles.scss';

const Logo = () => <img className="StudioLogo__wrapper" src={Icon} alt="UME" />

export default Logo;
